import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

/* 🔹 Slug formatter */
const formatSlug = (slug) => {
  return slug
    ?.toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
};

function CmsPage() {
  const { slug } = useParams();
  const formattedSlug = formatSlug(slug);

  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const res = await axios.get(
          `https://fosv2.foodship.net/api/fos/page/${formattedSlug}`
        );

        if (!res.data) {
          setNotFound(true);
        } else {
          setPage(res.data);
        }
      } catch (error) {
        setNotFound(true); // ✅ ONLY after API fails
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [formattedSlug]);

  /* 🔹 SEO */
  useEffect(() => {
    if (page?.title) {
      document.title = page.title;
    }
  }, [page]);

  /* 🔹 Loading */
  if (loading) {
    return (
      <div style={{ padding: "100px", textAlign: "center" }}>
        <div className="loader" />
        <p style={{ marginTop: "10px", color: "#777" }}>
          Loading content...
        </p>
      </div>
    );
  }

  /* 🔹 404 AFTER API */
  if (notFound) {
    return (
      <div style={{ textAlign: "center", padding: "120px 20px" }}>
        <h1 style={{ fontSize: "42px", marginBottom: "10px" }}>
          404
        </h1>
        <p style={{ color: "#666" }}>Page not found</p>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "70vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px 20px",
        fontFamily: "system-ui, sans-serif",
        textAlign: "center",
      }}
    >
      {/* 🔥 Title Center */}
      <h1
        style={{
          fontSize: "36px",
          marginBottom: "20px",
          fontWeight: "600",
        }}
      >
        {page.title}
      </h1>

      {/* 🔥 Description Center */}
      <div
        style={{
          maxWidth: "800px",
          lineHeight: "1.8",
          color: "#444",
          fontSize: "16px",
        }}
        dangerouslySetInnerHTML={{ __html: page.description }}
      />
    </div>
  );
}

export default CmsPage;